angular.module('unergie.main')
.controller('irrecoverabilityCertificatesCtrl', ($scope, $state, ApiAdmin, AlertManager, TableGeneratorService, ErrorCatcher) => {
    $scope.irrecoverabilityCertificates = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'status': { label: 'Statut', mode: 'search_wildcard' },
            'file_url': { label: 'PDF', mode: 'search_wildcard' },
            'certificate_date': { label: 'Date du certificat', mode: 'search_date' },
            'type': { label: 'Type', mode: 'search_wildcard' },
            'id_contract': { label: 'Id contrat', mode: 'search_wildcard' },
            'amount': { label: 'Montant', mode: 'search_operator' },
            'id_cir_payment': { label: 'Id paiement CIR', mode: 'search_operator' },
            'contractBalanceStatic.balance': { label: 'Solde SI', mode: 'search_operator' },
            'contractBalanceStatic.billing_balance': { label: 'Solde compta', mode: 'search_operator' },
        },
    }

    $scope.processCertificateFields = {
        bypassBalance: { label: 'Ne pas effectuer les contrôles sur la balance', type: 'checkbox' },
        bypassOdoo: { label: '<span class="red">Ne pas tenir compte de la différence de solde entre le SI et Odoo</span>', type: 'checkbox' },
    }

    $scope.processCertificateTemplate = {
        bypassBalance: false,
        bypassOdoo: false,
    }

    $scope.processCertificate = (certificate) => {
        certificate.processing = true
        return ApiAdmin.processIrrecoverabilityCertificates($scope.processCertificateTemplate, { ids: [certificate.id], idsContract: [certificate.id_contract] }).$promise
        .then((result) => {
            if (_.get(result, '0.name') === 'FunctionalError') {
                AlertManager.error(_.get(result, '0.message'))
            } else {
                AlertManager.success('Certificat traité')
            }
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            certificate.processing = false
        })
    }


    $scope.refresh = () => {
        TableGeneratorService.getTable($scope.irrecoverabilityCertificates, 'irrecoverability-certificates', null, null, { orderBy: '-status' })
    }


    $scope.refresh()
})
